const initialState = {
    isCreating: false,
    orderBeingRead: null,
    order: null,
    orderError: false,
    recentOrder: null,
    isReadingRecentOrder: false,
    orders: [],
    count: 0,
    invoiceSummary: {},
    cancellations: {},
    isRecalculatingTaxes: false,
    additionalTaxes: 0
}

export default initialState;
